import { Grid, makeStyles, useMediaQuery, useTheme } from '@material-ui/core';
import React from 'react';
import { CandidateViewerLogo, PoweredBy } from '../../assets/images';
import Login from '../../components/login';
import { COLORS } from '../../constants/colors';

const useStyles = makeStyles((theme) => ({
  root: {
    width: '100vw',
    height: '100vh',
    '& > :first-child': {
      backgroundColor: COLORS.grayScale[1],
    },
    '& > :nth-child(2)': {
      backgroundColor: COLORS.grayScale[2],
    },
  },
  formContainer: {
    width: '20rem',
    marginLeft: '5.875rem',
    [theme.breakpoints.down('sm')]: {
      margin: 0,
    },
  },
}));

const LoginPage = () => {
  const classes = useStyles();
  const theme = useTheme();
  const match = useMediaQuery(theme.breakpoints.down('sm'));

  return (
    <Grid
      className={classes.root}
      container
      direction={match ? 'column' : 'row'}
    >
      <Grid item xs container justify="center" alignItems="center">
        <Grid item>
          <img src={CandidateViewerLogo} alt="Candidate Viewer logo" />
          <Grid container justify="flex-end">
            <img src={PoweredBy} alt="Powered by AccelOne" />
          </Grid>
        </Grid>
      </Grid>
      <Grid
        item
        xs
        container
        alignItems="center"
        justify={match ? 'center' : 'flex-start'}
        direction={match ? 'column' : 'row'}
      >
        <Grid container className={classes.formContainer}>
          <Login />
        </Grid>
      </Grid>
    </Grid>
  );
};

export default LoginPage;
